import {LANGUAGE_DEFAULT} from '@/constants';

export default {
  namespaced: true,
  state: {
    lang: LANGUAGE_DEFAULT,
    scenariosMap: [
      new Map([
        ['welcome', {
          id: 0,
          name: '',
          product: 'CRsuite',
          topicAction: '',
          contentStage: '',
          creationLeadRequired: true,
        }],
        ['overview', {
          id: 1,
          name: 'Enterpise Overview',
          product: 'CRsuite',
          topicAction: 'Auditing/Operations',
          contentStage: '',
          creationLeadRequired: true,
        }],
        ['search', {
          id: 2,
          name: 'Interactive Search',
          product: 'CRsuite',
          topicAction: 'Security',
          contentStage: '',
          creationLeadRequired: true,
        }],
        ['user_account_changes', {
          id: 3,
          name: 'User Accounts Status Changes',
          product: 'CRsuite',
          topicAction: 'Auditing/Operations',
          contentStage: '',
          creationLeadRequired: true,
        }],
        ['folder_and_file_prm', {
          id: 4,
          name: 'File and Folders Permissions',
          product: 'CRsuite',
          topicAction: 'Auditing/Operations',
          contentStage: '',
          creationLeadRequired: true,
        }],
        ['windows_server_configuration', {
          id: 5,
          name: 'Windows Server Configuration',
          product: 'CRsuite',
          topicAction: 'Auditing/Operations',
          contentStage: '',
          creationLeadRequired: true,
        }],
        ['activity_outside_business_hours', {
          id: 6,
          name: 'Activity Outside Business Hours',
          product: 'CRsuite',
          topicAction: 'Auditing/Operations',
          contentStage: '',
          creationLeadRequired: true,
        }],
        ['alerts', {
          id: 7,
          name: 'Alerts',
          product: 'CRsuite',
          topicAction: 'Security',
          contentStage: '',
          creationLeadRequired: true,
        }],
        ['risk_assessment', {
          id: 8,
          name: 'Risk Assessment',
          product: 'CRsuite',
          topicAction: 'Security',
          contentStage: '',
          creationLeadRequired: true,
        }],
        ['data_discovery_and_classification', {
          id: 9,
          name: 'Data Discovery and Classification',
          product: 'nandc',
          topicAction: 'Security',
          contentStage: '',
          creationLeadRequired: true,
        }],
        ['behavior_anomaly_discovery', {
          id: 10,
          name: 'Behavior Anomaly Discovery',
          product: 'CRsuite',
          topicAction: 'Security',
          contentStage: '',
          creationLeadRequired: true,
        }],
        ['compliance_reports', {
          id: 11,
          name: 'Compliance',
          product: 'CRsuite',
          topicAction: 'Auditing/Operations',
          contentStage: '',
          creationLeadRequired: true,
        }],
      ]),
      new Map([
        ['ndc_welcome', {
          id: 0,
          name: '',
          product: 'ndc',
          topicAction: '',
          contentStage: '',
          creationLeadRequired: true,
        }],
        ['risk_mitigation', {
          id: 1,
          name: 'Minimize the exposure of sensitive data',
          product: 'ndc',
          topicAction: 'Security',
          contentStage: '',
          creationLeadRequired: true,
        }],
        ['clean_up_enterprise_content', {
          id: 2,
          name: 'Clean up enterprise content',
          product: 'ndc',
          topicAction: 'Information Governance',
          contentStage: '',
          creationLeadRequired: true,
        }],
        ['records_management', {
          id: 3,
          name: 'Automate records management processes',
          product: 'ndc',
          topicAction: 'Information Governance',
          contentStage: '',
          creationLeadRequired: true,
        }],
        ['ediscovery', {
          id: 4,
          name: 'Collect and preserve data for litigation',
          product: 'ndc',
          topicAction: 'Information Governance',
          contentStage: '',
          creationLeadRequired: true,
        }],
        ['dsar', {
          id: 5,
          name: 'Satisfy data subject access requests (DSARs)',
          product: 'ndc',
          topicAction: 'Information Governance',
          contentStage: '',
          creationLeadRequired: true,
        }],
      ]),
      new Map([
        ['sta_welcome', {
          id: 0,
          name: '',
          product: 'sta',
          topicAction: '',
          contentStage: '',
          creationLeadRequired: true,
        }],
        ['identify_data_security_risks', {
          id: 1,
          name: 'Identify data security risks',
          product: 'sta',
          topicAction: 'Security',
          contentStage: '',
          creationLeadRequired: true,
        }],
        ['streamline_data_access_reviews', {
          id: 2,
          name: 'Streamline data access reviews ',
          product: 'sta',
          topicAction: 'Security',
          contentStage: '',
          creationLeadRequired: true,
        }],
        ['satisfy_data_subject_access_requests', {
          id: 3,
          name: 'Satisfy data subject access requests (DSARs)',
          product: 'sta',
          topicAction: 'Security',
          contentStage: '',
          creationLeadRequired: true,
        }],
      ])
    ],
    scenariosNameMap: [
      new Map([
        [0, 'welcome'],
        [1, 'overview'],
        [2, 'search'],
        [3, 'user_account_changes'],
        [4, 'folder_and_file_prm'],
        [5, 'windows_server_configuration'],
        [6, 'activity_outside_business_hours'],
        [7, 'alerts'],
        [8, 'risk_assessment'],
        [9, 'data_discovery_and_classification'],
        [10, 'behavior_anomaly_discovery'],
        [11, 'compliance_reports'],
      ]),
      new Map([
        [0, 'ndc_welcome'],
        [1, 'risk_mitigation'],
        [2, 'clean_up_enterprise_content'],
        [3, 'records_management'],
        [4, 'ediscovery'],
        [5, 'dsar'],
      ]),
      new Map([
        [0, 'sta_welcome'],
        [1, 'identify_data_security_risks'],
        [2, 'streamline_data_access_reviews'],
        [3, 'satisfy_data_subject_access_requests'],
      ])
    ],
    currentScenario: 'welcome',
    currentScenarioId: 0,
    currentStep: 0,
    currentScreen: null,
    steps: [],
    dropdownState: false,
    lastDropdownState: false,
    blocked: false,
    webDemoType: 0,
    placeholder: {
      screen: '',
      tooltip: {
        text: '',
        showSteps: false,
        position: 'left',
        actions: []
      },
      viewArea: {
        height: 0,
        width: 0,
        x: 0,
        y: 0,
      },
    },
    tooltip: [
      {
        speaker: {
          img: 'https://img.netwrix.com/elements/onlineDemo/adam_stetson60.png',
          name: 'Adam Stetson,',
          title: 'Systems Engineer',
        },
        steps: 'out of',
      },
      {
        speaker: {
          img: '//img.netwrix.com/elements/onlineDemo/Thomas_Limpens.png',
          name: 'Thomas Limpens,',
          title: 'Ingénieur Avant-vente',
        },
        steps: 'sur',
      },
      {
        speaker: {
          img: '//img.netwrix.com/elements/onlineDemo/alex_bode.jpg',
          name: 'Alex Bode,',
          title: 'Systems Engineer',
        },
        steps: 'von',
      },
      {
        speaker: {
          img: '//img.netwrix.com/elements/onlineDemo/roberto.png',
          name: 'Roberto,',
          title: 'Ingegnere di sistemi',
        },
        steps: 'di',
      },
      {
        speaker: {
          img: '//img.netwrix.com/elements/onlineDemo/andrew.v001.jpg',
          name: 'Артём,',
          title: 'системный инженер',
        },
        steps: 'из',
      },
      {
        speaker: {
          img: 'https://img.netwrix.com/elements/onlineDemo/adam_stetson60.png',
          name: 'Adam Stetson,',
          title: 'Systems Engineer',
        },
        steps: 'de',
      },
    ],

    getActionColor(action) {
      let color = '#000000';

      switch (action) {
        case 'Added':
        case 'Successful Logon':
          color = '#5aba5a';
          break;
        case 'Failed Logon':
        case 'Removed':
          color = '#ed2b2f';
          break;
        case 'Modified':
        case 'Moved':
        case 'Renamed':
          color = '#f9b800';
          break;
        case 'Read (Failed Attempt)':
        case 'Read':
          color = '#7fbfdb';
          break;
        case 'Copied':
          color = '#7fbfdb';
          break;
        default:
          color = '#cecece';
          break;
      }

      return color;
    },
    operatorMenu: [
      'Equals',
      'Not equal to',
      'Starts with',
      'Ends with',
      'Contains',
      'Does not contain',
    ],
    operatorMenu2: [
      'Equals',
      'Not equal to',
      'Starts with',
      'Ends with',
      'Contains',
      'Does not contain',
      'In group',
    ],
    filterMenu: [
      'Who',
      'Action',
      'What',
      'When',
      'Where',
      'Object type',
      'Data source',
      'Monitoring plan',
      'Item',
      'Details',
      'Before',
      'After',
      'Everywhere',
    ],
    dataSourceMenu: [
      'Active Directory',
      'Azure AD',
      'Exchange',
      'Exchange Online',
      'File Servers',
      'Group Policy',
      'Logon Activity',
      'Netwrix API',
      'Oracle Database',
      'SharePoint',
      'SharePoint Online',
      'SQL Server',
      'User Activity (Video)',
      'VMware',
      'Windows Server',
    ],
    timeframeMenu: [
      'Today',
      'Yesterday',
      'Last 7 day',
      'Last week',
      'Last 14 days',
      'Last 30 days',
      'Last month',
      'Previous quater',
    ],
    actionsMenu: [
      'Added',
      'Removed',
      'Modified',
      'Add (Failed Attempt)',
      'Remove (Failed Attempt)',
      'Modify (Failed Attempt)',
      'Read',
      'Read (Failed Attempt)',
      'Renamed',
      'Moved',
      'Rename (Failed Attempt)',
      'Move (Failed Attempt)',
      'Checked in',
      'Checked out',
      'Discard check out',
      'Successful Logon',
      'Failed Logon',
      'Logoff',
      'Copied',
      'Sent',
      'Activated',
    ],
    filterTableData: [
      {
        filter: 'Data source',
        operator: 'Equals',
        value: 'Exchange',
      },
      {
        filter: 'What',
        operator: 'Contains',
        value: 'J.Brown@enterprise.com',
      },
      {
        filter: 'Object type',
        operator: 'Equals',
        value: 'mailbox item',
      },
      {
        filter: 'Object type',
        operator: 'Equals',
        value: 'mailbox folder',
      },
    ],
    filterAlertsTableData: [
      {
        filter: 'Object type',
        operator: 'Equals',
        value: 'Event Log',
      },
      {
        filter: 'Action',
        operator: 'Equals',
        value: 'Modified',
      },
      {
        filter: 'What',
        operator: 'Equals',
        value: 'Windows Event\\System',
      },
      {
        filter: 'What',
        operator: 'Equals',
        value: 'Windows Event\\Security',
      },
      {
        filter: 'What',
        operator: 'Equals',
        value: 'Windows Event\\Application',
      },
      {
        filter: 'Details',
        operator: 'Equals',
        value: 'Event Log Cleared',
      },
    ],
    tableData: [
      {
        'Who': 'ENTERPRISE\\D.Graham',
        'Object type': 'Mailbox Item',
        'Action': 'Read',
        'What': 'I.Wright@Enterprise.com\\Inbox\\High Priority',
        'Where': 'ex1.enterprise.com',
        'When': '4/6/2018 4:52:10 PM',
        'Details': 'Client: OWA',
      },
      {
        'Who': 'ENTERPRISE\\D.Graham',
        'Object type': 'Mailbox Folder',
        'Action': 'Read',
        'What': 'I.Wright@Enterprise.com\\Inbox\\',
        'Where': 'ex1.enterprise.com',
        'When': '4/6/2018 4:52:10 PM',
        'Details': 'Client: OWA',
      },
      {
        'Who': 'ENTERPRISE\\D.Graham',
        'Object type': 'Mailbox Item',
        'Action': 'Read',
        'What': 'I.Wright@Enterprise.com\\Sent Items\\Offer',
        'Where': 'ex1.enterprise.com',
        'When': '4/6/2018 4:52:10 PM',
        'Details': 'Client: OWA',
      },
      {
        'Who': 'ENTERPRISE\\D.Graham',
        'Object type': 'Mailbox Folder',
        'Action': 'Read',
        'What': 'I.Wright@Enterprise.com\\Sent Items',
        'Where': 'ex1.enterprise.com',
        'When': '4/6/2018 4:52:10 PM',
        'Details': 'Client: OWA',
      },
      {
        'Who': 'ENTERPRISE\\D.Graham',
        'Object type': 'Mailbox Item',
        'Action': 'Read',
        'What': 'I.Wright@Enterprise.com\\Deleted Items\\Client Info',
        'Where': 'ex1.enterprise.com',
        'When': '4/6/2018 4:52:10 PM',
        'Details': 'Client: OWA',
      },
      {
        'Who': 'ENTERPRISE\\D.Graham',
        'Object type': 'Mailbox Folder',
        'Action': 'Read',
        'What': 'I.Wright@Enterprise.com\\Deleted Items',
        'Where': 'ex1.enterprise.com',
        'When': '4/6/2018 4:52:10 PM',
        'Details': 'Client: OWA',
      },
    ],
  },
  mutations: {
    setLanguage(state, data) {
      state.lang = data;
    },
    setWebDemoType(state, data) {
      state.webDemoType = data;
    },
    setScenario(state, data) {
      state.currentScenario = data;
    },
    setSteps(state, data) {
      state.steps = data;
    },
    setScenarioId(state, data) {
      state.currentScenarioId = data;
    },
    resetSteps(state) {
      state.currentStep = 0;
    },
    nextStep(state) {
      state.currentStep++;
    },
    prevStep(state) {
      state.currentStep--;
    },
    setScreen(state) {
      if (state.steps.length) {
        state.currentScreen = state.steps[state.currentStep].screen;
      }
    },
    goToStep(state, step) {
      state.currentStep = step;
    },
    toggleDropdown(state) {
      state.dropdownState = !state.dropdownState;
    },
    openDropdown(state) {
      state.dropdownState = true;
    },
    closeDropdown(state) {
      state.dropdownState = false;
    },
    setLastDropdownState(state) {
      state.lastDropdownState = state.dropdownState;
    },
    lockApp(state) {
      state.blocked = true;
    },
    unlockApp(state) {
      state.blocked = false;
    },
  },
  getters: {
    step: state => {
      return state.steps[state.currentStep] || state.placeholder;
    },
    totalSteps: state => {
      return state.steps.length;
    },
    speaker: state => {
      return state.tooltip[state.lang].speaker;
    },
    texts: state => {
      return state.tooltip[state.lang];
    },
  },
  actions: {
    setScenario({ commit, state }, scenario) {
      commit('setScenarioId', scenario.value);
      commit('setScenario', state.scenariosNameMap[state.webDemoType].get(scenario.value));
      commit('resetSteps');
      commit('setScreen');
    },
    nextStep({ commit }) {
      commit('nextStep');
      commit('setScreen');
    },
    prevStep({ commit }) {
      commit('prevStep');
      commit('setScreen');
    },
    setSteps({ commit }, steps) {
      commit('setSteps', steps);
    },
    goToStep({ commit }, step) {
      commit('goToStep', step);
    },
    setLanguage({ commit }, data) {
      commit('setLanguage', data.value);
    },
    setWebDemoType({ commit }, data) {
      commit('setWebDemoType', data.value);
    },
    lockApp({ commit }) {
      commit('lockApp');
    },
    unlockApp({ commit }) {
      commit('unlockApp');
    },
  },
};
